import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Button, Select, Modal, Form } from "@gpstrackit/gtc-react-controls";
import {
  getPreferences,
  savePreference,
} from "Redux/actions";
import { reset } from "./redux/slice";
import FilterPdfColumns from "../components/columnsFilter";
import TagsFilter from "../components/tagsFilter";
import StatusFilter from "../components/statusFilter";
import FilterServices from "../components/servicesFilter";
import VehicleFilter from "../components/vehicleFilter";
import { sendGenericExport, clearRedux } from "Redux/actions";
import { GetFormatForMoment } from 'Core/data/Helpers';

const optionsSelect = [
  { id: "CSV", label: "CSV" },
  { id: "PDF", label: "PDF" },
];

const columnHeaders = [
  "tags",
  "vehicle",
  "lastServiceDate",
  "odometerAtLastService",
  "currentOdometer",
  "engineHoursAtLastService",
  "currentEngineHours",
  "nextServiceDue",
  "nextServiceStatus",
  "daysInterval",
  "engineHoursInterval",
  "milesInterval",
  "lastReportedLocation",
];

const INITIAL_FILTERS = {
  type: null,
  tags: [],
  status: [],
  services: [],
  vehicles: [],
};

const KEY_PREFERENCE = "maintenanceExportVehicles";

const ExportVehicles = () => {
  const dispatch = useDispatch();
  const { messages } = useIntl();

  const { loading, open } = useSelector(
    (state) => state.maintenanceExportVehiclesRedux
  );
  const { user, authenticatedId } = useSelector((state) => state.securityRedux);
  const { preferencesUser, returnServer } = useSelector(
    (state) => state.preferencesRedux
  );
  const [isPdf, setIsPdf] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [errorStatus, setErrorStatus] = useState()

  useEffect(() => {
    dispatch(getPreferences({ entityName: "User", entityId: authenticatedId, force: true }));
  }, []);

  useEffect(() => {
    if (preferencesUser && returnServer) {
      let preferencesKeyTemp = preferencesUser.find(
        (x) => x.preferenceKey === KEY_PREFERENCE
      );
      let preferencesJSON =
        (preferencesKeyTemp &&
          preferencesKeyTemp.preferenceValue != "" &&
          preferencesKeyTemp.preferenceValue) ||
        "{}";
      preferencesJSON = JSON.parse(preferencesJSON);
      if (preferencesJSON?.length > 0) {
        setFilters({ ...filters, type: { id: "PDF", label: "PDF" } });
        setIsPdf(true);
        setSelectedColumns(preferencesJSON);
      } else {
        setFilters({ ...filters, type: { id: "CSV", label: "CSV" } });
        setIsPdf(false);
        setSelectedColumns([]);
      }
    }
  }, [returnServer]);

  const savePreferences = () => {
    if (authenticatedId) {
      if (isPdf) {
        dispatch(
          savePreference(
            "User",
            authenticatedId,
            KEY_PREFERENCE,
            selectedColumns
          )
        );
      } else {
        dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: KEY_PREFERENCE, preferenceValue: [] }));
      }
    }
  };

  const buildFunctionString = (key) => {
    let functionString = `return row?.${key}`
    if (key === 'lastServiceDate') {
      const momentFormat = GetFormatForMoment(user.dateformat);
      functionString = `return moment(row?.lastServiceDate).format('${momentFormat}')`
    }
    return {
      header: messages[`exportVehicles_${key}`],
      column: key,
      functionString
    }
  }

  const handleGenericExport = () => {
    let headers = []
    const type = isPdf ? 'Pdf' : 'Csv'
    const selectedHeaders = isPdf ? selectedColumns : columnHeaders
    headers = selectedHeaders.map(x => {
      const buildHeader = buildFunctionString(x)
      return buildHeader
    }) || [];

    const getTagsIds = filters?.tags?.map(item => `${item?.id}`)


    dispatch(sendGenericExport(
      "maintenanceDueExport",
      type,
      `
        query getMaintenanceExport ( $status: [String], $services: [Int], $vehicles: [Int], $tags: [String], $limit: Int, $offset: Int) {
          data: getMaintenanceExport (status: $status, services: $services, vehicles: $vehicles, tags: $tags, limit: $limit, offset: $offset) {
              items {
                  tags
                  vehicle
                  lastServiceDate
                  odometerAtLastService
                  currentOdometer
                  engineHoursAtLastService
                  currentEngineHours
                  nextServiceDue
                  nextServiceStatus
                  daysInterval
                  engineHoursInterval
                  milesInterval
                  lastReportedLocation
              }
              total
          }
        }
        `,
      {
        tags: getTagsIds?.length > 0 ? getTagsIds : null,
        services: filters?.services?.length > 0 ? filters?.services : null,
        status: filters?.status?.length > 0 ? filters?.status[0] === -1 ? null : filters?.status : null,
        vehicles: filters?.vehicles?.length > 0 ? filters?.vehicles : null,
        limit: 10,
        offset: 0
      },
      headers,
      { unit: 'pt', size: 'A4', orientation: 'portrait', fontSize: 10 }
    ));
  }

  const handleClose = () => {
    dispatch(reset());
    setIsPdf(false);
    setFilters(INITIAL_FILTERS);
    setSelectedColumns([]);
  };

  const handleSuccess = () => {
    if (!filters?.type) {
      return setErrorStatus({ ...errorStatus, type: messages["exportVehicles_requireType"] })
    }
    if (filters?.type?.id === 'PDF' && selectedColumns?.length === 0) {
      return setErrorStatus({ ...errorStatus, selectedColumns: messages["exportVehicles_requirePdfFields"] })
    }
    savePreferences();
    handleGenericExport()
    handleClose()
  };

  return (
    <Modal
      title={messages["exportVehicles_title"]}
      size="small"
      loading={loading}
      open={open}
      handleClose={handleClose}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            disabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button
            variant="primary"
            onClick={(e) => handleSuccess()}
            disabled={loading}
          >
            {messages["export"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "12px 25px" }}>
        <Select
          label={messages["exportVehicles_fileFormat"]}
          id="selectFormat"
          options={optionsSelect}
          onChange={(value) => {
            setIsPdf(value?.id === 'PDF' ? true : false)
            setFilters({ ...filters, type: value });
            setErrorStatus({ ...errorStatus, type: null })
          }}
          value={filters?.type}
          isClearable
          isSearchable
          textField="label"
          valueField="id"
        />
        {
          errorStatus?.type && <p style={{ color: 'red' }}>{errorStatus?.type}</p>
        }
        {
          errorStatus?.selectedColumns && <p style={{ color: 'red' }}>{errorStatus?.selectedColumns}</p>
        }
        {isPdf && (
          <FilterPdfColumns
            selectedColumns={selectedColumns}
            setSelectedColumns={setSelectedColumns}
            columnHeaders={columnHeaders}
            errorStatus={errorStatus}
            setErrorStatus={setErrorStatus}
          />
        )}
        <div style={{ marginBottom: 8, marginTop: 10 }}>
          <TagsFilter
            id="tags_export"
            values={filters?.tags || []}
            onChange={(items) => setFilters({ ...filters, tags: items })}
          />
        </div>
        <div style={{ width: "80%", marginTop: 20 }}>
          <StatusFilter
            values={(x) => filters.status.includes(x.id)}
            onChange={(items) => {
              if (items.length === 0) setFilters({ ...filters, status: [-1] });
              else
                setFilters({
                  ...filters,
                  status: items.map((x) => x.id),
                });
            }}
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <FilterServices
            value={(x) => filters.services.includes(x)}
            onChange={(items = []) => {
              setFilters({
                ...filters,
                services: (items && items.map((x) => x.id)) || [],
              });
            }}
          />
        </div>
        <div style={{ marginTop: 20, marginBottom: 300 }}>
          <VehicleFilter
            value={(x) => filters.vehicles.includes(x)}
            onChange={(items) => {
              setFilters({
                ...filters,
                vehicles: (items && items.map((x) => x.id)) || [],
              });
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExportVehicles;
